// ── Geotab well-known diagnostic IDs ─────────────────────────────────────
// These are stable Geotab system diagnostic identifiers used in StatusData queries.

export const DiagnosticFuelLevelId              = 'DiagnosticFuelLevelId';
export const DiagnosticOdometerId               = 'DiagnosticOdometerId';
export const DiagnosticOdometerAdjustmentId     = 'DiagnosticOdometerAdjustmentId';
export const DiagnosticBatteryVoltageId         = 'DiagnosticBatteryVoltageId';
export const DiagnosticExternalBatteryVoltageId = 'DiagnosticExternalBatteryVoltageId';

// Fallback name patterns used by findDiagnosticValue()
export const SPEED_FALLBACK_IDS  = [
  'DiagnosticRoadSpeedId',
  'DiagnosticGpsVehicleSpeedId',
  'DiagnosticEngineRoadSpeedId',
];
export const IGNITION_FALLBACK_IDS = ['DiagnosticIgnitionId'];

// Battery voltage valid range (volts)
export const BATTERY_MIN_V = 10;
export const BATTERY_MAX_V = 30;
